// AUTO-GENERATED from apps/usa/region.config.js — do not edit here.
// USA edition — region configuration.
// Source of truth lives in /apps/usa; synced into src/regions/ by
// scripts/sync-regions.js (CRA cannot import from outside src/).
const usaConfig = {
  id: "usa",
  label: "United States",
  countries: ["US"],
  locale: "en-US",
  currency: {
    code: "USD",
    symbol: "$",
    format: (amount) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      }).format(amount),
  },
  phone: {
    placeholder: "+1 (555) 000-0000",
    countryCode: "+1",
  },
  contact: {
    email: "info@terces.io",
    whatsapp: true,
    whatsappLink: "https://wa.me/919281115822",
    // No dedicated US phone line yet — USA edition routes calls through
    // WhatsApp and email instead of showing an international number.
    showPhone: false,
    phoneDisplay: null,
    phoneTel: null,
  },
  address: {
    lines: ["Serving restaurant operators", "across the United States"],
    note: "Remote-first consulting, nationwide",
  },
  terminology: {
    // US industry says "ghost kitchen"; India says "cloud kitchen".
    cloudKitchen: "ghost kitchen",
    cloudKitchens: "ghost kitchens",
    deliveryPlatforms: "DoorDash, Uber Eats & Grubhub",
  },
  content: {
    heroTag: "Data-Driven Restaurant Consulting",
    heroTagline: "Helping restaurants across the USA grow smarter",
    marketNoun: "restaurants across the United States",
    caseStudiesIntro:
      "Real transformations from Terces engagements — cost control, multi-unit expansion, and digital growth you can replicate in your market.",
    caseStudyRegionNote:
      "Results from our global client base, reported as delivered.",
    currencyExample: "$2,900",
    footerBlurb:
      "Restaurant consulting built for US operators — helping independent restaurants, ghost kitchens, and multi-unit groups scale with systems, not guesswork.",
    footerTagline: "Serving restaurant operators across the United States",
    adBudgetAnswer:
      "We recommend a minimum of $800–1,200 per month for effective campaigns. This covers ad spend and management. We can scale based on your goals and results.",
    revenueRanges: [
      "Under $250K",
      "$250K – $1M",
      "$1M – $2.5M",
      "$2.5M – $5M",
      "Above $5M",
    ],
    careersBlurb:
      "Join Terces Solutions and help transform food businesses across the United States. Explore open roles in restaurant consulting, operations, and technology.",
  },
  seo: {
    titleSuffix: "Terces Solutions — Restaurant Consulting, USA",
    homeTitle:
      "Terces Solutions — Restaurant Consulting & Operations Experts, USA",
    homeDescription:
      "Terces Solutions helps US restaurants, ghost kitchens, and multi-unit groups cut food costs, optimize labor, and scale profitably with measurable, guaranteed results.",
    keywords:
      "restaurant consulting USA, food cost reduction, restaurant profitability, ghost kitchen consulting, restaurant operations, menu engineering",
    areaServed: "US",
  },
};

export default usaConfig;
